<div class="header-user-actions">
  <button
    nz-button
    nzType="text"
    nz-dropdown
    nzTrigger="click"
    [nzDropdownMenu]="regionMenu"
    class="region-trigger"
    (nzVisibleChange)="onRegionMenuVisible($event)"
  >
    <span nz-icon nzType="global"></span>
    <span class="region-label">{{ regionLabel() }}</span>
  </button>

  <button
    nz-button
    nzType="text"
    nz-dropdown
    nzTrigger="click"
    [nzDropdownMenu]="languageMenu"
    class="language-trigger"
  >
    <span nz-icon nzType="translation"></span>
    <span class="language-label">{{ activeLanguageLabel() }}</span>
  </button>

    <a nz-dropdown nzTrigger="click" [nzDropdownMenu]="userMenu" class="user-trigger" [attr.title]="userLabel()">
      <nz-avatar [nzSrc]="avatarUrl()" nzIcon="user" nzSize="small" class="avatar"></nz-avatar>
      @if (email()) {
        <span class="user-email">{{ email() }}</span>
      }
    </a>
</div>

<nz-dropdown-menu #regionMenu="nzDropdownMenu">
  <!-- No nzSelectable: click must not change highlight before switch succeeds / confirm is accepted. -->
  <ul nz-menu>
    @for (option of visibleRegionOptions(); track option.value) {
      <li
        nz-menu-item
        [nzSelected]="region() === option.value"
        (click)="onSwitchRegion(option.value)"
      >
        {{ regionName(option.value) }}
      </li>
    }
  </ul>
</nz-dropdown-menu>

<nz-dropdown-menu #languageMenu="nzDropdownMenu">
  <ul nz-menu nzSelectable>
    @for (option of languageOptions; track option.value) {
      <li nz-menu-item [nzSelected]="activeLanguage() === option.value" (click)="onSwitchLanguage(option.value)">
        {{ option.label }}
      </li>
    }
  </ul>
</nz-dropdown-menu>

<nz-dropdown-menu #userMenu="nzDropdownMenu">
  <div class="user-menu">
    <div class="user-menu-profile">
      <nz-avatar [nzSrc]="avatarUrl()" nzIcon="user" nzSize="large" class="user-menu-avatar"></nz-avatar>
      <div class="user-menu-identity">
        <div class="user-menu-name">{{ userLabel() }}</div>
        <div class="user-menu-caption">{{ 'shell.header.signed_in_as' | transloco }}</div>
      </div>
    </div>

    <div class="user-menu-meta">
      @if (email()) {
        <div class="user-menu-meta-row">
          <span class="user-menu-meta-label">{{ 'shell.header.email' | transloco }}</span>
          <span class="user-menu-meta-value">{{ email() }}</span>
        </div>
      }
      <div class="user-menu-meta-row">
        <span class="user-menu-meta-label">{{ 'shell.header.current_region' | transloco }}</span>
        <span class="user-menu-meta-value">{{ regionLabel() }}</span>
      </div>
      <div class="user-menu-meta-row">
        <span class="user-menu-meta-label">{{ 'shell.header.version' | transloco }}</span>
        <span class="user-menu-meta-value">{{ version() }}</span>
      </div>
    </div>

    <div class="user-menu-actions">
      <button type="button" class="user-menu-action" (click)="onOpenAccountInfo()">
        <span nz-icon nzType="user"></span>
        <span>{{ 'shell.header.account_info' | transloco }}</span>
      </button>
      <button type="button" class="user-menu-action user-menu-logout" (click)="onLogout()">
        <span nz-icon nzType="logout"></span>
        <span>{{ 'shell.header.logout' | transloco }}</span>
      </button>
    </div>
  </div>
</nz-dropdown-menu>
